import * as React from "react"
import { connect } from "react-redux"

import { GlobalState } from "../../../store"
import { IWelcomePage } from "../index"

type StateProps = IWelcomePage

type Props = StateProps

export const Greeting = ({ greeting, userName }: Props): JSX.Element => (
    <>
        <h1 className="tw-text-center tw-absolute tw-inset-0 theme-blurred-text">
            {userName}
        </h1>
        <h2 className="tw-relative tw-mb-4 tw-text-center">
            <span data-ft-greeting>{greeting}</span>,&nbsp;
            <span data-ft-user-name>{userName}</span>
        </h2>
    </>
)

const mapStateToProps = (state: GlobalState): StateProps => state.welcomePage

export default connect(mapStateToProps, {})(Greeting)
